export * from '@primeuix/themes/material/inputgroup';
export { default } from '@primeuix/themes/material/inputgroup';
